import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class History {
  private readonly http = inject(HttpClient);

  userDetails(): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.user.user}`);
  }

  getMessageHistory(filters: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiPrefix}${environment.message.messageHistory}`, {
      params: filters
    });
  }

  downloadMessageHistory(filters: any = {}): Observable<Blob> {
    return this.http.get(`${environment.apiPrefix}${environment.message.downloadMessageHistory}`, {
      params: filters,
      responseType: 'blob'
    });
  }
}
